<template>
  <div class="relative size-10 shrink-0">
    <div class="absolute inset-0 rounded-2xl" :class="containerClass">
      <div class="absolute inset-[20%] overflow-hidden">
        <img :src="starSrc" alt="" class="absolute inset-0 size-full" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  import standardStar from '../assets/stars/standard.svg?url';
  import silverStar from '../assets/stars/silver.svg?url';
  import goldStar from '../assets/stars/gold.svg?url';
  import platinumStar from '../assets/stars/platinum.svg?url';
  import promoStar from '../assets/stars/promo.svg?url';

  const props = defineProps<{ levelName: string }>();

  const STAR_MAP: Record<string, string> = {
    Standard: standardStar,
    Silver: silverStar,
    Gold: goldStar,
    Platinum: platinumStar,
    promo: promoStar,
  };

  const CONTAINER_CLASS: Record<string, string> = {
    Standard: 'bg-[rgba(122,172,160,0.2)]',
    Silver: 'bg-[rgba(141,158,188,0.2)]',
    Gold: 'bg-[rgba(211,170,116,0.2)]',
    Platinum: 'bg-[rgba(71,100,169,0.2)]',
    promo: 'promo-star-bg',
  };

  const starSrc = computed(
    () => STAR_MAP[props.levelName] ?? STAR_MAP['Standard'],
  );
  const containerClass = computed(
    () => CONTAINER_CLASS[props.levelName] ?? CONTAINER_CLASS['Standard'],
  );
</script>

<style scoped>
  .promo-star-bg {
    background-image: linear-gradient(
      91.03deg,
      rgba(79, 105, 255, 0.2) 1.15%,
      rgba(125, 171, 255, 0.2) 100%
    );
  }
</style>
